<script>
import BaseConfig from './_base-config.vue';
import { planTypes } from '@/common/constants';

export default {
  name: 'AudioConferencingReadonly',
  extends: BaseConfig,
  data() {
    return {
      readonly: true,
      isExpanded: false,
      notification: '',
    };
  },

  computed: {
    selectedZoomRoom() {
      return this.getSelectedPlans.filter((p) => p.type === planTypes.ZOOM_ROOMS)[0];
    },
  },

  watch: {
    selectedZoomRoom() {
      this.handleNotification();
    },
    mx_unlimitedBoughtRelatePlanTypes: {
      immediate: true,
      handler() {
        this.handleNotification();
      },
    },
  },

  methods: {
    handleNotification() {
      const hasMeeting = this.mx_unlimitedBoughtRelatePlanTypes.includes(planTypes.ZOOM_MEETING);
      const hasZR = this.mx_unlimitedBoughtRelatePlanTypes.includes(planTypes.ZOOM_ROOMS) || this.selectedZoomRoom;
      if (hasMeeting && hasZR) {
        this.notification = this.$t('billing.tollfree.require_equal_number_tip_for_zr');
      } else if(hasMeeting) {
        this.notification = this.$t('billing.tollfree.require_equal_number_tip');
      }
    },
  },
};
</script>
